import * as actionTypes from "../../../constants/ActionTypes/AdminPortal/InvoicePosting";

const initialState = {
    data: {},
    loading: false,
    success: false,
    error: null
}

const TESIInvoice_VIEW = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TESI_INVOICES_INIT:
            return {
                ...state,
                loading: true,
                success: false
            }
        
        case actionTypes.GET_TESI_INVOICES_SUCCESS:
            return {
                ...state,
                data: action.data,
                loading: false,
                error: null,
                success: true
            }
        
        case actionTypes.GET_TESI_INVOICES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                data: {}
            }
        case actionTypes.GET_TESI_INVOICES_RESET:
            return {
                data: {},
                loading: false,
                success: false,
                error: null
            }
        default:
            return {...state}
    }
}

export default TESIInvoice_VIEW